import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  EditButton,
  ShowButton,
  Filter,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  TextInput,
  ChipField
} from "react-admin";
import { SUPERADMIN } from "../../constant/TypeRole";
import Actions from '../Actions'

const InterestingFilter = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
  return (
    <Filter {...props}>
      <TextInput source="name_contains" />
      <TextInput source="type_contains" />
      <ReferenceArrayInput
        alwaysOn
        style={{ minWidth: "200px" }}
        source="project"
        reference="project"
        filter={filter}
      >
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
    </Filter>
  );
};

export const InterestingList = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
  return (
    <List
      {...props}
      title="interesting.interesting"
      actions={<Actions create />}
      bulkActions={false}
      filters={<InterestingFilter />}
      filterDefaultValues={filter}
    >
      <Datagrid>
        <div />
        <TextField source="name" />
        <TextField source="type" />
        <ReferenceField linkType={false} source="project" reference="project">
          <ChipField source="name" />
        </ReferenceField>
        <EditButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/components/interesting/InterestingList.js